import React from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import MetaData from "../../components/layout/MetaData";

function OrderSuccess() {
  return (
    <>
    <MetaData title={"Order Success"}/>
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 mx-auto">
          {" "}
          {/* Added mx-auto class */}
          <div className="card p-4">
            <Image
              src="/img/order_success.png"
              alt="Order Success"
              className="mb-4 row justify-content-center"
              style={{ width: "150px" , height: "150px" , margin: "auto"}}
            />
            <div className="text-center">
              <h2 className="text-center mb-4">
                Order Successfully Completed!
              </h2>
              <p className="text-center">
                Thank you for your order. Your order has been successfully
                processed.
              </p>
              <p className="text-center">
                You will receive an email confirmation shortly.
              </p>
              <div className="text-center mt-4">
                <Link to="/" className="btn btn-primary">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default OrderSuccess;
